import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_ME } from '~/contexts/me/router/routes'

const ME_PERSONAL_SPACE_WIKI_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_WIKI,
  path: 'wiki',
  component: () => import('~/contexts/me/pages/personal-space/index/wiki.vue'),
  meta: { name: 'me-personal-space-filtered-wiki' },
}

const ME_PERSONAL_SPACE_WEDO_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_WEDO,
  path: 'wedo',
  component: () => import('~/contexts/me/pages/personal-space/index/wedo.vue'),
  meta: { name: 'me-personal-space-filtered-wedo' },
}

const ME_PERSONAL_SPACE_MEDIA_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_MEDIA,
  path: 'media',
  component: () => import('~/contexts/me/pages/personal-space/index/media.vue'),
  meta: { name: 'me-personal-space-filtered-media' },
}

const ME_PERSONAL_SPACE_IDEA_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_IDEA,
  path: 'idea',
  component: () => import('~/contexts/me/pages/personal-space/index/idea.vue'),
  meta: { name: 'me-personal-space-filtered-idea' },
}

const ME_PERSONAL_SPACE_CONTENT_TYPE_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_CONTENT_TYPE,
  path: ':content_type',
  component: () => import('~/contexts/me/pages/personal-space/index/[content_type].vue'),
  meta: { name: 'me-personal-space-filtered-{content_type}' },
}

const ME_PERSONAL_SPACE_HOME_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_HOME,
  path: '',
  component: () => import('~/contexts/me/pages/personal-space/index/index.vue'),
  meta: { name: 'me-personal-space' },
}

export const ME_PERSONAL_SPACE_FACETS_ROUTE: RouteRecordRaw = {
  path: 'personal-space',
  children: [
    ME_PERSONAL_SPACE_WIKI_ROUTE,
    ME_PERSONAL_SPACE_WEDO_ROUTE,
    ME_PERSONAL_SPACE_MEDIA_ROUTE,
    ME_PERSONAL_SPACE_IDEA_ROUTE,
    ME_PERSONAL_SPACE_CONTENT_TYPE_ROUTE,
    ME_PERSONAL_SPACE_HOME_ROUTE,
  ],
  component: () => import('~/contexts/me/pages/personal-space/index.vue'),
  meta: { name: 'me-personal-space' },
}

export const ME_PERSONAL_SPACE_SETTINGS_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PERSONAL_SPACE_SETTINGS,
  path: 'personal-space/settings',
  component: () => import('~/contexts/me/pages/personal-space/settings.vue'),
  meta: { name: 'me-personal-space-settings',
  },
}
